import template from './wizard_leave_setup_employees.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupEmployees
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.recipients = ko.observableArray([]);
		this.employee_group = ko.observableArray();
		this.departments = ko.observableArray();
		this.leave_type_id = ko.observable(null);
		this.leave_linked_id = ko.observable(null);
		this.auto_link = ko.observable(false);
		this.selected_employee = ko.observable();

		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
			{
				if (!this.recipients().some(obj => obj.employee_id === newValue.employee_id))
				{
					this.recipients.push({
						employee_id: newValue.employee_id,
						name: `${newValue.firstname} ${newValue.surname}`,
						start_date: newValue.date_started,
						disable_edit: false
					});
				}
				else
					Grape.alerts.alert({type: 'error', message: tr('This employee is already added'), title: tr('Duplicate employee')});
			}
		});
	}

	close()
	{
		this.dialog.close();
	}
}

class WizardLeaveSetupEmployeesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupEmployees(this);
	}

	async init()
	{
		console.log('bindings', this.bindings);

		// Handle leave_type_id
		if (this.bindings.data.leave_object?.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_object.leave_type_id);
		else if (this.bindings.data.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		// Handle recipients
		let employees = this.bindings.recipients || [];
		if (employees.length > 0)
		{
			let rep = employees.map((x) => ({
				...x,
				disable_edit: true
			}));
			this.viewModel.recipients(rep);
		}

		// Handle auto_link
		if (this.bindings.data.leave_object?.auto_link != null)
			this.viewModel.auto_link(this.bindings.data.leave_object.auto_link);
		else if (this.bindings.auto_link != null)
			this.viewModel.auto_link(this.bindings.data.auto_link);

		// Get employee groups 
		let res = await Grape.fetches.getJSON('/api/record', { 
			table: 'v_employee_group', 
			schema: 'savanna' 
		});
		
		if (res.records)
			this.viewModel.employee_group(res.records);

		res = await Grape.fetches.getJSON('/api/record', { 
			table: 'v_department_company', 
			schema: 'savanna' 
		});

		if (res.records)
		{
			for (let i = 0; i < res.records.length; i++)
				res.records[i].name = res.records[i].department + ' (' + res.records[i].company + ')';

			this.viewModel.departments(res.records);
		}
	}

	async back_wizard()
	{
		if (this.viewModel.leave_type_id())
		{
			this.close();
			return;
		}

		let data = Object.assign({}, this.bindings, {
			recipients: this.viewModel.recipients(),
			auto_link: this.viewModel.auto_link()
		});

		this.viewModel.close();
		await Grape.dialog.open('WizardLeaveSetupRestrictions', data);
	}
	
	async next_wizard()
	{
		let response = await Grape.alerts.confirm({
			type: 'success',
			title: tr('Save leave type'),
			message: tr('Do you want to save this leave type? You can edit it at a later stage'),
			accept_text: tr('Save'),
			cancel_text: tr('Go back and edit leave type')
		});
			
		if (response)
			await this.save_leave_type();

		this.viewModel.close();
	}

	async add_department_group(v, e)
	{
		let result = await Grape.fetches.getJSON('/api/record', {
			table: 'v_active_employees_department',
			schema: 'savanna',
			limit: 1000000,
			filter: [{ value: v.department_id, op: '=', field: 'department_id' }]
		});
		
		if (result.status != 'ERROR')
		{
			if (result.records != null && result.records != undefined)
			{
				for (let i = 0; i < result.records.length; i++)
				{
					if (!this.viewModel.recipients().some(obj => obj.employee_id === result.records[i].employee_id))
					{
						result.records[i].name = result.records[i].firstname + ' ' +
							result.records[i].surname + ' (' + result.records[i].id_number + ')';
						
						this.viewModel.recipients.push({
							employee_id: result.records[i].employee_id,
							name: result.records[i].name,
							start_date: result.records[i].date_started,
							disable_edit: false
						});
					}
				}
			}
		}
	}

	async save_leave_type()
	{
		// Build data object from bindings structure
		let leave_object = this.bindings.leave_object || this.bindings.data.leave_object || {};
		
		console.log('bindings when saving', this.bindings);
		let data = {
			description: leave_object.description,
			icon: leave_object.icon,
			hexcolor: leave_object.hexcolor,
			category: leave_object.category,
			plugin_context: leave_object.plugin_context,
			leave_type_id: leave_object.leave_type_id || 0,
			cycle_length_text: this.bindings.data.cycle_length_text || leave_object.cycle_length_text,
			cycle_length_number: this.bindings.data.cycle_length_number || leave_object.cycle_length_number,
			cycle_amount: this.bindings.data.cycle_amount || leave_object.cycle_amount,
			is_earned: this.bindings.data.is_earned != null ? this.bindings.data.is_earned : leave_object.is_earned,
			is_switch_type: this.bindings.data.is_switch_type != null ? this.bindings.data.is_switch_type : leave_object.is_switch_type,
			is_capping_active: this.bindings.data.is_capping_active != null ? this.bindings.data.is_capping_active : leave_object.is_capping_active,
			capped_amount: this.bindings.data.capped_amount || leave_object.capped_amount,
			visible_on_profile: this.bindings.data.visible_on_profile || leave_object.visible_on_profile,
			show_available_and_cycle_for_roles: this.bindings.data.show_available_and_cycle_for_roles || leave_object.show_available_and_cycle_for_roles,
			leave_type_linked_holidays: this.bindings.data.leave_type_linked_holidays || leave_object.leave_type_linked_holidays,
			leave_type_linked_restriction_rules: this.bindings.data.leave_type_linked_restriction_rules || leave_object.leave_type_linked_restriction_rules,
			auto_link: this.viewModel.auto_link(),
			ignore_holidays: this.bindings.data.ignore_holidays != null ? this.bindings.data.ignore_holidays : leave_object.ignore_holidays,
			ignore_weekends: this.bindings.data.ignore_weekends != null ? this.bindings.data.ignore_weekends : leave_object.ignore_weekends
		};

		let res = await Grape.fetches.postJSON('/admin/leave_type/save', data);
		
		Utils.wrap_api_result(res, tr, async () => {
			if (res.status == 'OK' && res.leave_type_id)
			{
				// Leave type added, next step: link employees
				let employees = this.viewModel.recipients();
				let leave_objects = [];

				for (let i = 0; i < employees.length; i++)
				{
					leave_objects.push({
						employee_id: employees[i].employee_id,
						date_start: employees[i].start_date,
						cycle_date_start: employees[i].start_date,
						leave_type_id: res.leave_type_id
					});
				}

				let result = await Grape.fetches.postJSON('/employee/save_linked_leave_batch', { 
					link_entries: leave_objects, 
					id: res.leave_type_id 
				});
				
				if (result.status == 'OK')
				{
					await Grape.alerts.alert({
						type: 'success', 
						message: tr('Successfully added leave type & linked employees'), 
						title: tr('Success')
					});
					this.close();
					location.reload();
				}
				else
				{
					Grape.alerts.alert({
						type: 'error', 
						message: tr('Leave type saved but there was an error in linking all the employees. Please go to the individual profiles to confirm.'),
						title: tr('Error')
					});
				}
			}
			else
			{
				Grape.alerts.alert({
					type: 'error', 
					message: tr('Error saving leave type'), 
					title: tr('Error')
				});
			}
		});
	}

	remove_employee(v, e)
	{
		let linked_employees = this.viewModel.recipients();
		let filtered = linked_employees.filter((n) => n.employee_id !== v.employee_id);
		this.viewModel.recipients(filtered);
	}

	async remove_employee_from_leave(v, e)
	{
		let data = ko.toJS(v);

		// Get employee leave linked
		let leave_linked_res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_linked',
			schema: 'public',
			filter: [
				{ value: this.viewModel.leave_type_id(), op: '=', field: 'leave_type_id'},
				{ value: data.employee_id, op: '=', field: 'employee_id'}
			]
		});

		if (leave_linked_res.records)
			data.leave_linked_id = leave_linked_res.records[0].leave_linked_id;

		let response = await Grape.alerts.confirm({ 
			type: 'warning', 
			title: tr('Warning'), 
			message: tr('Are you sure you want to remove this linked leave?') 
		});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/leave/remove_linked_leave', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ 
						type: 'success', 
						message: tr('Successfully removed employee.'), 
						title: tr('Success') 
					});
					this.remove_employee(v, e);
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ 
						type: 'error', 
						message: tr('Something went wrong...'), 
						title: tr('Error') 
					});
			}
		}
	}

	async back_and_save()
	{
		// Build data object from bindings structure
		let leave_object = this.bindings.leave_object || {};

		let data = {
			description: leave_object.description,
			icon: leave_object.icon,
			hexcolor: leave_object.hexcolor,
			category: leave_object.category,
			plugin_context: leave_object.plugin_context,
			leave_type_id: leave_object.leave_type_id || 0,
			cycle_length_text: this.bindings.cycle_length_text || leave_object.cycle_length_text,
			cycle_length_number: this.bindings.cycle_length_number || leave_object.cycle_length_number,
			cycle_amount: this.bindings.cycle_amount || leave_object.cycle_amount,
			is_earned: this.bindings.is_earned != null ? this.bindings.is_earned : leave_object.is_earned,
			is_switch_type: this.bindings.is_switch_type != null ? this.bindings.is_switch_type : leave_object.is_switch_type,
			is_capping_active: this.bindings.is_capping_active != null ? this.bindings.is_capping_active : leave_object.is_capping_active,
			capped_amount: this.bindings.capped_amount || leave_object.capped_amount,
			visible_on_profile: this.bindings.visible_on_profile || leave_object.visible_on_profile,
			show_available_and_cycle_for_roles: this.bindings.show_available_and_cycle_for_roles || leave_object.show_available_and_cycle_for_roles,
			leave_type_linked_holidays: this.bindings.leave_type_linked_holidays || leave_object.leave_type_linked_holidays,
			leave_type_linked_restriction_rules: this.bindings.leave_type_linked_restriction_rules || leave_object.leave_type_linked_restriction_rules,
			auto_link: this.viewModel.auto_link(),
			ignore_holidays: this.bindings.ignore_holidays != null ? this.bindings.ignore_holidays : leave_object.ignore_holidays,
			ignore_weekends: this.bindings.ignore_weekends != null ? this.bindings.ignore_weekends : leave_object.ignore_weekends
		};

		let res = await Grape.fetches.postJSON('/admin/leave_type/save', data);

		if (res.status != 'OK')
		{
			Grape.alerts.alert({
				type: 'error', 
				message: tr('Error saving leave type'), 
				title: tr('Error')
			});
			return;
		}

		let employees = this.viewModel.recipients();
		let leave_objects = [];

		// Save newly added employees (disable_edit === false)
		for (let i = 0; i < employees.length; i++)
		{
			if (!employees[i].disable_edit)
			{
				leave_objects.push({
					employee_id: employees[i].employee_id,
					date_start: employees[i].start_date,
					cycle_date_start: employees[i].start_date,
					leave_type_id: this.viewModel.leave_type_id()
				});
			}
		}

		if (leave_objects.length > 0)
		{
			let api = await Grape.fetches.postJSON('/employee/save_linked_leave_batch', { 
				link_entries: leave_objects, 
				id: this.viewModel.leave_type_id() 
			});
			
			if (api.status == 'OK')
			{
				await Grape.alerts.alert({
					type: 'success', 
					message: tr('Successfully added leave type & linked employees'), 
					title: tr('Success')
				});
				this.close();
			}
			else
			{
				Grape.alerts.alert({
					type: 'error', 
					message: tr('Leave type saved but there was an error in linking all the employees. Please go to the individual profiles to confirm.'),
					title: tr('Error')
				});
			}
		}
		else
		{
			await Grape.alerts.alert({
				type: 'success', 
				message: tr('Changes has been saved'), 
				title: tr('Success')
			});
			this.close();
		}
	}
}

export default {
	name: 'WizardLeaveSetupEmployees',
	dialog_class: WizardLeaveSetupEmployeesPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_employees',
	provider: 'ps'
};
